import React from 'react';
import styled, { css } from 'styled-components';

import { useJetourHomeData } from '@/modules/JetourHome/hooks';
import { AboutCardPrimary } from '@/components/LandingWidgets';
import { Image as AboutCardPrimaryImage } from '@/components/LandingWidgets/components/AboutCardPrimary';
import { ContentContainer } from '@/modules/JetourHome/common.styles';
import { media } from '@/utils/mixin';

function AboutDealer() {
  const {
    aboutDealerImage,
    aboutDealerMobileImage,
    aboutDealerTitle,
    aboutDealerTopText,
    aboutDealerBenefits,
    aboutDealerBottomText,
  } = useJetourHomeData();

  if (!aboutDealerImage || !aboutDealerTitle || !aboutDealerTopText) {
    return null;
  }

  return (
    <Component>
      <ContentContainer>
        <AboutCardPrimary
          id={5}
          image={aboutDealerImage}
          imageMobile={aboutDealerMobileImage}
          title={aboutDealerTitle}
          topText={aboutDealerTopText}
          benefits={
            aboutDealerBenefits && aboutDealerBenefits.length !== 0
              ? aboutDealerBenefits.map(({ image, text }) => ({
                  image,
                  text: text ?? '',
                }))
              : []
          }
          bottomText={aboutDealerBottomText ?? ''}
        />
      </ContentContainer>
    </Component>
  );
}

export default AboutDealer;

const Component = styled.section`
  padding: 30px 0;

  ${AboutCardPrimaryImage} {
    height: 320px;

    ${media.tablet(css`
      height: auto;
    `)}
  }

  ${media.tablet(css`
    padding: 20px 0;
  `)}
`;
